import React from "react";

import { Box } from "@mui/material";

import ConnectionSectionDescription from "./ConnectionSectionDescription";

interface ConnectionSectionHeaderProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
}

const ConnectionSectionHeader: React.FC<ConnectionSectionHeaderProps> = ({
    title,
    description,
    action,
}) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            width: "100%",
            flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
    >
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
                className="title connection-card-title"
                sx={{ marginBottom: "0 !important", width: "100%" }}
            >
                <span>{title}</span>
            </Box>
            {description ? (
                <ConnectionSectionDescription>
                    {description}
                </ConnectionSectionDescription>
            ) : null}
        </Box>
        {action ? (
            <Box
                sx={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                {action}
            </Box>
        ) : null}
    </Box>
);

export default ConnectionSectionHeader;
